<mat-form-field2
  class="mat-block"
  [hidePlaceholder]="hidePlaceholder"
  [showLabel]="showLabel"
  i18n-matTooltip
  matTooltip="Send the notify after the specified hours"
>
  <input
    type="text"
    placeholder="Delay Hours"
    [formControl]="ctrl"
    matInput
    required
    [min]="min"
    [max]="max"
    [disabled]="disabled"
  />
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    <ng-container i18n>Value is required</ng-container>
  </mat-error>
  <mat-error *ngIf="ctrl.hasError('min')">
    <ng-container i18n>Min value is</ng-container>&nbsp; <strong>{{ min }}</strong></mat-error
  >
  <mat-error *ngIf="ctrl.hasError('max')">
    <ng-container i18n>Max value is</ng-container>&nbsp; <strong>{{ max }}</strong></mat-error
  >
</mat-form-field2>
